var exports = {
  "x6": "SettingsHeadingLinkButton.module__button___ZTEyZk",
  "x2": "SettingsHeadingLinkButton.module__buttonCopied___ZTEyZk",
  "Kk": "SettingsHeadingLinkButton.module__icon___ZTEyZk",
};

module.exports = exports;
